<template>
	<div class="container">
		<div class="login-wrap">
			<div class="login-l" :style="'background-image:url('+loginBgUrl+')'">
				<!-- <img  src="@/assets/login.png"/> -->
			</div>
			<div class="login-r">
				<a href="/" target="_blank"><img class="login-logo" src="@/assets/logo.png"/></a>
				<div class="login-title">
					<h3>B端管理系统</h3>
					<span class="line"></span>
				</div>
				<div class="login-form">
					<div class="from-list">
						<div class="form-list-icon">
							<img src="@/assets/default_head.png"/>
						</div>
						<input type="text" v-model="userName" placeholder="请输入账号"/>
					</div>
				</div>
				<div class="login-form">
					<div class="from-list">
						<div class="form-list-icon">
							<img src="@/assets/default_head.png"/>
						</div>
						<input type="password" v-model="password" placeholder="请输入密码"/>
					</div>
				</div>
				<div class="login-tips">
					<el-checkbox @change="toAutoLogin" v-model="autoLogin">自动登录</el-checkbox>
					<a href="/settle">开设账号</a>
				</div>
				<div class="login-btn" @click="toLogin">登 录</div>
				<!-- <div class="agreement">
					登录即表示您已同意圆满假期平台<a href="#">服务协议</a>和<a href="#">隐私政策</a>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Login',
		components: {
			
		},
		data(){
			return {
				pageHeight: '400px',
				userName: '',
				password: '',
				autoLogin: false,
				loginBgUrl: ''
			}
		},
		mounted(){
			
		},
		created(){
			let username = localStorage.getItem('username');
			let password = localStorage.getItem('password');
			if (username && password) {
				this.userName = username;
				this.password = password;
				this.autoLogin = true;
			}
			this.getLoginImg()
		},
		methods: {
			toAutoLogin(e){
				console.log(e)
				this.autoLogin = e
			},
			windowSize(){
				let pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
				this.pageHeight = pageHeight + 'px'
			},
			//获取登录左侧图片
			async getLoginImg(){
				let param = {
					code: 'LOGIN_URL'
				}
				ajaxParam(param)
				const res = await post('admin/sys/getByCode', qs.stringify(param))
				if (res.data.code == 200) {
					this.loginBgUrl = res.data.entity.configValue
				}
			},
			async toLogin(){
				if(this.userName==''){
					this.$message.error('请输入用户名')
					return
				}
				if(this.password==''){
					this.$message.error('请输入密码')
					return
				}
				let param = {
					userName: this.userName,
					password: this.password
				}
				ajaxParam(param)
				const res = await post('/admin/index/login', qs.stringify(param))
				if(res.data.code==200){
					if(this.autoLogin){
						// 将账户名和密码存储在localStorage中
						localStorage.setItem('username', this.userName);
						localStorage.setItem('password', this.password);
					} else {
						localStorage.removeItem('username')
						localStorage.removeItem('password')
					}
					//存储登录信息
					//localStorage.setItem('user',JSON.stringify(res.data.entity))
					localStorage.setItem('companyId', res.data.entity.companyId)
					localStorage.setItem('token', res.data.entity.uuid)
					localStorage.setItem('companyName', res.data.entity.companyName)
					localStorage.setItem('nickName', res.data.entity.nickName)
					localStorage.setItem('userId', res.data.entity.id)
					localStorage.setItem('userName', res.data.entity.userName)
					//登录成功，进入首页
					this.$message.success('登录成功！')
					console.log(res.data)
					setTimeout(()=>{
						this.$router.push({
							path: '/admin/index'
						})
					},300)
					
				} else {
					this.$message.error(res.data.msg)
				}
				
				
			}
		}
	}
</script>

<style scoped lang="less">
	.container{
		background: #fff;
		overflow: hidden;
		height: 100vh;
	}
	.login-wrap{
		display: flex;
		height: 100%;
		.login-l{
			width: 55%;
			height: 100%;
			background: url('../../../assets/login.png') no-repeat center center;
			background-size: cover;
			img{
				display: block;
				width: 100%;
				height: 100%;
			}
		}
		.login-r{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: 100%;
			.login-logo{
				width: 200px;
				height: 100px;
			}
			.login-title{
				display: flex;
				flex-direction: column;
				align-items: center;
				h3{
					margin-top: 10px;
					font-size: 18px;
					font-weight: bold;
				}
				.line{
					display: block;
					width: 40px;
					height: 4px;
					background: #EB6B1B;
					margin-top: 6px;
					overflow: hidden;
				}
			}
			
			.from-list{
				display: flex;
				align-items: center;
				width: 490px;
				height: 48px;
				background: #f5f7fa;
				border-radius: 4px;
				margin-top: 30px;
				.form-list-icon{
					margin-right: 20px;
					border-right: 1px solid #e1e2e5;
					img{
						width: 20px;
						height: 20px;
						margin: 0 20px;
					}
				}
				
				input{
					flex: 1;
					background: transparent;
				}
			}
			.login-tips{
				display: flex;
				justify-content: space-between;
				width: 490px;
				margin-top: 15px;
				color: #409EFF;
				a{
					color: #409EFF;
				}
			}
			.login-btn{
				width: 490px;
				height: 48px;
				background: #eb6b1b;
				border-radius: 4px;
				margin-top: 40px;
				text-align: center;
				line-height: 48px;
				color: #fff;
				font-size: 18px;
				cursor: pointer;
			}
			.agreement{
				margin-top: 60px;
				line-height: 30px;
				a{
					color: #eb6b1b;
				}
			}
		}
	}
</style>